import { Component, Input, OnInit } from '@angular/core';
import { Section } from 'src/app/model/shared/section';

@Component({
  selector: 'app-api-reference-wsdl-section',
  templateUrl: './api-reference-wsdl-section.component.html',
  styleUrls: ['./api-reference-wsdl-section.component.scss']
})
export class ApiReferenceWsdlSectionComponent implements OnInit {
  @Input() sections: Section[] = [];

  constructor() {}

  ngOnInit(): void {}
}
